export const shortDayMap = {
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thur',
    Friday: 'Fri',
    Saturday: 'Sat',
    Sunday: 'Sun',
}

export const GALLERY_MIN = 6
export const GALLERY_MAX = 20